import '@affine/component/theme';

import { setupBrowser } from '@affine/core/bootstrap';

await setupBrowser();
